import { render, staticRenderFns } from "./ContainerDetail.vue?vue&type=template&id=5050114f&"
import script from "./ContainerDetail.vue?vue&type=script&lang=ts&"
export * from "./ContainerDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports